// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal__sjSn1OpDYC{width:680px}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/analytics/components/panels/components/export/components/modal/analyticsExportModal.module.scss"],"names":[],"mappings":"AAAA,mBACE,WAAA","sourcesContent":[".modal {\n  width: 680px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `modal__sjSn1OpDYC`
};
export default ___CSS_LOADER_EXPORT___;
